import React from "react";
import "../../Components/WhyMeda/WhyMeda.css";
import whyMedaPic from "../../Images/Content/whyMeda.png";

function WhyMedaHealth() {
  return (
    <section className="whyMedaHealth">
      <div className="whyMedaPicContainer">
        <img src={whyMedaPic} className="whyMedaPic"></img>
      </div>
      <div className="whyMedaContent">
        <h2>Why MedaHealth?</h2>
        <p className="intro">
          We believe getting health insurance should feel personal, not painful.
          Here’s why clients trust MedaHealth to guide them.
        </p>
        <div className="reasons-grid">
          <div className="reason">
            <h4>No Pressure, Ever</h4>
            <p>
              We’re here to help you understand your options — not to sell you
              something you don’t need.
            </p>
          </div>
          <div className="reason">
            <h4>Licensed & Trusted</h4>
            <p>
              Our agents are fully licensed and experienced in matching clients
              with the right plans.
            </p>
          </div>
          <div className="reason">
            <h4>Customized to You</h4>
            <p>
              We take the time to learn about your health needs, budget, and
              goals so we can offer the best fit.
            </p>
          </div>
          <div className="reason">
            <h4>Nationwide Coverage</h4>
            <p>
              No matter where you live, we can help — we work with top carriers
              in all 50 states.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyMedaHealth;
